import { CompanyDocument, PersonalDocument } from '@scansource-brazil/zeus-core-ui/utils';
import type { GeneralObject } from '@scansource-brazil/zeus-core-ui/types';

export class SalesCommission {
  salesCommissionId: string = '';
  invoiceNumber: string = '';
  invoiceSerieNumber: string = '';
  installment: string = '';
  amountInstallment: string = '';
  netCommission: string = 'R$ 0,00';
  totalInvoiceAmount: string = 'R$ 0,00';
  totalNetCommission: string = 'R$ 0,00';
  totalGrossCommission: string = 'R$ 0,00';
  finalCustomerName: string = '';
  finalCustomerDocument: CompanyDocument | PersonalDocument | string = '';
  salesOrderNumber: string = '';
  paymentCondition: string = '';
  billingDate: Date | string = '';
  salesCommissionInstallments: {
    items: SalesCommissionInstallment[];
    totals: GeneralObject;
  } = {} as any;
  salesCommissionItems: {
    items: SalesCommissionItem[];
    totals: GeneralObject;
  } = {} as any;

  constructor(data?: SalesCommission) {
    Object.assign(this, data);
  }
}

export class SalesCommissionInstallment {
  installment: string = '';
  value: string = 'R$ 0,00';
  dueDate: Date | string = '';
  paymentDate: Date | string = '';
  netValue: string = 'R$ 0,00';
  status: { color: string; content: string } = {
    color: 'info',
    content: 'COMMISSION.STATUS.PENDING',
  };

  constructor(data: SalesCommissionInstallment) {
    Object.assign(this, data);
  }
}

export class SalesCommissionItem {
  partNumber: string = '';
  amount: string = 'R$ 0,00';
  grossValue: string = 'R$ 0,00';
  ipiValue: string = 'R$ 0,00';
  icmsValue: string = 'R$ 0,00';
  pisValue: string = 'R$ 0,00';
  cofinsValue: string = 'R$ 0,00';
  netUnitPrice: string = 'R$ 0,00';

  constructor(data: SalesCommissionItem) {
    Object.assign(this, data);
  }
}

export class SalesCommissionInputDTO {
  salesCommissionId: string = '';
  invoiceNumber: string = '';
  invoiceSerieNumber: string = '';
  installment: string = '';
  amountInstallment: string = '';
  netCommission: number = 0;
  totalInvoiceAmount: number = 0;
  totalNetCommission: number = 0;
  totalGrossCommission: number = 0;
  finalCustomerName: string = '';
  finalCustomerDocument: string = '';
  salesOrderNumber: number = 0;
  paymentCondition: string = '';
  billingDate: string = '';
  salesCommissionInstallments: SalesCommissionInstallmentInputDTO[] = [];
  salesCommissionItems: SalesCommissionItemsInputDTO[] = [];

  constructor(data?: SalesCommissionInputDTO) {
    Object.assign(this, data);
  }
}

export class SalesCommissionInstallmentInputDTO {
  installment: string = '';
  status: string = '';
  value: number = 0;
  dueDate: string = '';
  paymentDate: string = '';
  netValue: number = 0;

  constructor(data: SalesCommissionInstallmentInputDTO) {
    Object.assign(this, data);
  }
}

export class SalesCommissionItemsInputDTO {
  partNumber: string = '';
  amount: number = 0;
  grossValue: string = '';
  ipiValue: number = 0;
  icmsValue: number = 0;
  pisValue: number = 0;
  cofinsValue: number = 0;
  netUnitPrice: number = 0;

  constructor(data: SalesCommissionItemsInputDTO) {
    Object.assign(this, data);
  }
}

export class SalesCommissionFilters {
  filterOption?: string;
  filterValue?: string;
  paymentDate?: Date[];
  dueDate?: Date[];
  commissionStatus?: string;
}

export class SalesCommissionFiltersOutputDTO {
  genericTerm?: string;
  filteredField?: string;
  paymentDateStart?: string;
  paymentDateEnd?: string;
  dueDateStart?: string;
  dueDateEnd?: string;
  commissionStatus?: string | number;
  page?: number;
  pageSize?: number;
  sort?: string;
  sortName?: string;
}

export class SalesCommissionListItem {
  salesCommissionId: string = '';
  finalCustomerDocument: CompanyDocument | PersonalDocument | string = '';
  finalCustomerName: string = '';
  invoiceNumber: string = '';
  invoiceSerieNumber: string = '';
  salesOrderNumber: string = '';
  installment: string = '';
  installmentAmount: string = '';
  installmentDueDate: string | Date = '';
  installmentPaymentDate: string | Date = '';
  status: { color: string; content: string } = {
    color: 'info',
    content: 'COMMISSION.STATUS.PENDING',
  };
  netValue: string = '';

  constructor(data?: SalesCommissionListItem) {
    Object.assign(this, data);
  }
}

export class SalesCommissionListItemInputDTO {
  salesCommissionId: string = '';
  finalCustomerDocument: string | null = null;
  finalCustomerName: string | null = null;
  invoiceNumber: string = '';
  invoiceSerieNumber: string = '';
  salesOrderNumber: number = 0;
  installment: string = '';
  installmentAmount: string = '';
  installmentDueDate: string = '';
  installmentPaymentDate: string = '';
  status: string = '';
  netValue: number = 0;

  constructor(data?: SalesCommissionListItemInputDTO) {
    Object.assign(this, data);
  }
}
